import React, {PropsWithChildren, useEffect} from 'react';
import Resource from '../core/serverresource';
import AdfsAuthGate from './adfs/AdfsAuthGate';
import {persistAuthMode, resolveAuthMode} from './authMode';
import EntraIdAuthGate from './entraid/EntraIdAuthGate';

type AuthGateProps = PropsWithChildren<{}>;

export const AuthGate = ({children}: AuthGateProps): JSX.Element => {
    const mode = resolveAuthMode({
        storage: window.sessionStorage,
        searchParams: new URLSearchParams(window.location.search),
        isEntraIdForced: Resource.isEntraIdForced(),
    });

    useEffect(() => {
        persistAuthMode(mode, {
            storage: window.sessionStorage,
            url: new URL(window.location.href),
            history: window.history,
        });
    }, [mode]);

    return mode === 'entra-id'
        ? <EntraIdAuthGate>{children}</EntraIdAuthGate>
        : <AdfsAuthGate>{children}</AdfsAuthGate>;
};

